export const COPYRIGHTS = {
  StartingYear: new Date().getFullYear().toString(),
  ToYear: new Date().getFullYear().toString(),
  CompanyName: 'MRI Software LLC'
};
